import { FormControl } from "@angular/forms";
import { environment } from "../../environments/environment";

export const emailPattern = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z.]{2,6}$/;
export const mobilePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

export function password_validation(control: FormControl) {
	let password: any = control.value;
	if (password == null || password == undefined) {
		password = "";
	}
	let errObj: any = {};
	if (password.length < 8) {
		errObj.minlengtherror = true;
	}
	const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	if (!specialChars.test(password)) {
		errObj.specialcharerror = true;
	}
	const upper = /[A-Z]/;
	const lower = /[a-z]/;
	const digit = /\d/;
	if (!upper.test(password)) {
		errObj.uppercaseerror = true;
	}
	if (!lower.test(password)) {
		errObj.lowercaseerror = true;
	}
	if (!digit.test(password)) {
		errObj.digiterror = true;
	}
	return errObj ? errObj : null;
}

export function getDeviceId(): string {
	const key = 'hc_device_id';
	let deviceId = localStorage.getItem(key);
	if (!deviceId) {
		deviceId = crypto.randomUUID();
		localStorage.setItem(key, deviceId);
	}
	return deviceId;
}

export const iconList: any = [
	{ type: "xlsx", icon: "file-excel" },
	{ type: "xls", icon: "file-excel" },
	{ type: "xlsm", icon: "file-excel" },
	{ type: "csv", icon: "file-csv" },
	{ type: "doc", icon: "file-word" },
	{ type: "docx", icon: "file-word" },
	{ type: "docm", icon: "file-word" },
	{ type: "mp4", icon: "file-video" },
	{ type: "avi", icon: "file-video" },
	{ type: "pdf", icon: "file-pdf" },
	{ type: "jpg", icon: "file-image" },
	{ type: "jpeg", icon: "file-image" },
	{ type: "png", icon: "file-image" },
	{ type: "gif", icon: "file-image" },
	{ type: "jfif", icon: "file-image" },
	{ type: "zip", icon: "file-archive" },
	{ type: "rar", icon: "file-archive" },
	{ type: "mp3", icon: "file-audio" },
	{ type: "webm", icon: "file-audio" },
	{ type: "txt", icon: "file-alt" }
];

export function isImage(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
	} catch (error) {
		return false;
	}
}

export function isPdf(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "pdf";
	} catch (error) {
		return false;
	}
}